window.addEventListener('customily-options-loaded', function (e) {
    $('#cl_optionsapp .custom-swatch-presentation .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
    $('#cl_optionsapp .squareswatchaddon .swatch-container label ,img').each(function () {
        $(this).attr('style', '');
    });
   
    $('#cl_optionsapp .color-block-custom .swatch-container label').each(function (){
        $(this).css({ 'display':'block', 'width': '100%', 'height': '', 'max-width': '', 'min-height': '' , 'min-width':'', 'max-height':'' });
       
    });
    $('input.needsclick.needsfocus').each(function(){
      $(this).next('label').next('span.label-txt').remove();
      var label_txt = $(this).val();
      $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
  });

  // Function to scroll to the top
// function scrollToTop() {
//   window.scrollTo({ top: 0, behavior: 'smooth' });
// }
// if (window.innerWidth <= 768) {
//   document.querySelector('.customily-download-button').addEventListener('click', function() {
//     setTimeout(function() {
//       // Scroll to top after image is replaced
//       scrollToTop();
//     }, 3000); // Adjust timeout based on the time it takes for the image to replace
//   });
// }
  
});

$('body').on('click', '.custom-swatch-presentation .customily-swatch', function () {
   
    setTimeout(function () {
        if ($('.custom-rebins').length > 0) {
            $('.custom-rebins .swatch-container label ,img').each(function () {
                $(this).attr('style', '');
            });
        var elements = $('.custom-rebins').find('.option_name');
        if (!elements.next('.custom-notice').length) {
            elements.after('<span class="custom-notice">Not available for sealed bag or favor box</span>');
          }
        }
      $('input.needsclick.needsfocus').each(function(){
          $(this).next('label').next('span.label-txt').remove();
          var label_txt = $(this).val();
          $(this).next('label').after('<span class="label-txt">' + label_txt + '</span>');
      });
      
    }, 500);
});


$('body').on('click','.description_data',function(e){
    e.preventDefault();
    var desc = $(this).attr('data-description');
    var desc_title = $(this).attr('data-title');
    $(this).hide();
    $('.description_data.'+desc_title).show();
    $('.rich-text-content').hide();
    $('.rich-text-content.'+desc).show();         
});

$('body').on('change','.gift_check_btn',function(){
  if ($(this).is(':checked')){
    $('.gift_message .line-item-property__field .gift-note').attr('name','properties[Gift Message]');
  }else{
    $('.gift_message .line-item-property__field .gift-note').attr('name','');
  }
});

window.addEventListener('scroll', function() {
    const button = document.querySelector('.customily-preview-button');
    const stickyClass = 'sticky-button';
    
    if (window.scrollY > 40) { // Check if scrolled down
        button.classList.add(stickyClass);
    } else {
        button.classList.remove(stickyClass);
    }
});